import styled from 'styled-components';

export const StyledEventBlock = styled.div<{
  included?: boolean;
  accent?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 12px;
  margin-bottom: 16px;
  padding: 14px 14px 14px 16px;
  border-width: 1px 1px 1px 4px;
  border-style: ${({ included }) =>
    included ? 'solid' : 'dashed solid dashed dashed'};
  border-color: ${({ accent, theme }) =>
    `${theme.color.porcelain} ${theme.color.porcelain} ${
      theme.color.porcelain
    } ${accent || theme.color.brightTurquoise}`};
  border-radius: 12px;
  background: ${({ included, theme }) =>
    included ? theme.color.aquaSqueeze : theme.color.white};
  text-align: left;
`;

export const StyledEventCopy = styled.div`
  min-width: 0;
`;

export const StyledEventTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: ${({ theme }) => theme.color.pickledBluewood};
`;

export const StyledEventMeta = styled.div`
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.4;
  color: ${({ theme }) => theme.color.BlueBayoux};
`;

export const StyledEventActions = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
`;

export const StyledAddEventButton = styled.button`
  height: 32px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: ${({ theme }) => theme.color.brightTurquoise};
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.black};
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.brightTurquoise};
    outline-offset: 2px;
  }
`;

export const StyledViewEventLink = styled.a`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.color.brightTurquoise};
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.black};
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    opacity: 0.9;
  }
`;

export const StyledRemoveEventButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${({ theme }) => theme.color.baliHai};
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
  }

  &:hover {
    background: ${({ theme }) => theme.color.white};
    color: ${({ theme }) => theme.color.shark};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.brightTurquoise};
    outline-offset: 2px;
  }
`;

export const StyledEventLinkNote = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.color.bittersweet};
`;
